import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { QUERY_KEYS } from '@restworld/utils-common';
import { useJobPositionsService } from '@restworld/data-services';
import { showToast } from '@restworld/ui-ds-base';

export function useDuplicateJobPosition() {
  const queryClient = useQueryClient();
  const jobPositionsService = useJobPositionsService();
  const router = useRouter();
  const { t } = useTranslation('job-positions-page');

  const { mutate: duplicateJobPosition, isPending: isDuplicating } = useMutation({
    mutationFn: ({ jobPositionId }: { jobPositionId: string }) =>
      jobPositionsService.duplicate({
        jobPositionId,
        params: {
          status_key: 'jp_draft',
        },
      }),
    onSuccess: (response) => {
      // Invalidate the job positions list query to refresh the data
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_POSITIONS.LIST],
      });

      // Redirect to onboarding review page with the new JP ID
      const newJpId = response?.data?.id;
      if (newJpId) {
        router.push(`/employer/job-positions/onboarding?job_position_id=${newJpId}&step=review`);
      }
    },
    onError: () => {
      showToast(t('jp_duplicate_error'), 'error');
    },
  });

  return { duplicateJobPosition, isDuplicating };
}
